import Vue from "vue";
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  preload: 1,
  lazyComponent: true
});



// WEBPACK FOOTER //
// ./src/lazyload.js